import type { SVGProps } from 'react';

const SvgReset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M21 12c0-2.4-.94-4.66-2.64-6.36A8.94 8.94 0 0 0 12 3c-2.4 0-4.66.94-6.36 2.64L5 6.28V4.01c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1H6.1l.95-.95A6.96 6.96 0 0 1 12 5.01c1.87 0 3.63.73 4.95 2.05A6.96 6.96 0 0 1 19 12.01c0 1.87-.73 3.63-2.05 4.95A6.96 6.96 0 0 1 12 19.01a6.96 6.96 0 0 1-4.95-2.05 7 7 0 0 1-1.53-2.3.998.998 0 1 0-1.85.75 8.9 8.9 0 0 0 1.97 2.96c1.7 1.7 3.96 2.64 6.36 2.64s4.66-.94 6.36-2.64S21 14.41 21 12.01z"
    />
  </svg>
);
export default SvgReset;
